import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from '@components/Layout';
import { Seo, PreloadHeroImage } from '@components';
import { createComponent } from '@helpers/createComponent';
import dataLayerPush from '@helpers/dataLayerPush';

const Page = ({ data, pageContext }) => {
  const { body } = data.strapiLandingPage;
  return (
    <Layout>
      {body &&
        body.map(
          (props, index) =>
            createComponent({
              ...props,
              index,
              breadcrumbs: pageContext?.breadcrumbs
            })
          // eslint-disable-next-line function-paren-newline
        )}
    </Layout>
  );
};

export const Head = ({ location, data }) => {
  const { pathname } = location;
  const { seo, title, body } = data.strapiLandingPage;

  dataLayerPush({
    event: `page_load`,
    interaction: {
      page_title: title,
      page_slug: pathname
    }
  });

  return (
    <>
      <Seo seo={seo} pathname={pathname} defaultTitle={title} />
      {body && <PreloadHeroImage firstComponent={body[0]} />}
    </>
  );
};

export const query = graphql`
  query ($slug: String) {
    strapiLandingPage(slug: { eq: $slug }) {
      title
      body {
        ...Body
      }
      seo {
        ...Seo
      }
    }
  }
`;

export default Page;
